import { createSlice } from "@reduxjs/toolkit";
import { FetchInvoiceDetailList, FetchInvoiceList } from "./invoiceAction";

interface InvoiceState {
  invoice: any | null;
  invoiceDetails: any | null;
  loading: boolean;
  error: string | null;
  totalRecord: number;
  detailsTotalRecord: number;
  openInvoiceModal: boolean;
  openInvalidRowsModal: boolean;
  modalData: any;
  editInvoiceModalOpen?: boolean;
  editInvoiceData?: any;
  openInvoiceUploadModal: boolean;
  modalUploadData: any;
  invalidModalData: any;
  openInvoiceListModal: boolean;
  modalListData: any
  openDocumentUploadModal: boolean;
  modalDocumentUploadData: any;
  currentInvoiceNumber: string | null;
  openInvoiceDataStoreModal: boolean;
  modalUploadDataStore: any;
shippingData: any | null;
}

const initialState: InvoiceState = {
  invoice: [],
  invoiceDetails: [],
  loading: false,
  error: null,
  totalRecord: 0,
  detailsTotalRecord: 0,
  openInvoiceModal: false,
  openInvalidRowsModal: false,
  modalData: { data: [], headers: [] },
  editInvoiceModalOpen: false,
  editInvoiceData: null,
  openInvoiceUploadModal: false,
  modalUploadData: { data: [], headers: [] },
  invalidModalData: { data: [], headers: [] },
  openInvoiceListModal: false,
  modalListData: { data: [], headers: [] },
  openDocumentUploadModal: false,
  modalDocumentUploadData: { data: [], headers: [], invoiceNumber: "", isViewMode: false },
  currentInvoiceNumber: null,
  openInvoiceDataStoreModal: false,
  modalUploadDataStore: { data: [], headers: [] },
shippingData: null,
};

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    setOpenInvoiceModal: (state, { payload }) => {
      state.openInvoiceModal = true;
      state.modalData = payload;
    },
    setCloseInvoiceModal: (state) => {
      state.openInvoiceModal = false;
      state.modalData = { data: [], headers: [] };
    },
    setOpenInvalidRowsModal: (state, { payload }) => {
      state.openInvalidRowsModal = true;
      state.invalidModalData = payload;
    },
    setCloseInvalidRowsModal: (state) => {
      state.openInvalidRowsModal = false;
      state.invalidModalData = { data: [], headers: [] };
    },
    setOpenEditInvoiceModal: (state, { payload }) => {
      state.editInvoiceModalOpen = true;
      state.editInvoiceData = payload;
    },
    setCloseEditInvoiceModal: (state) => {
      state.editInvoiceModalOpen = false;
      state.editInvoiceData = null;
    },
    setOpenInvoiceUploadModal: (state, { payload }) => {
      state.openInvoiceUploadModal = true;
      state.modalUploadData = payload;
    },
    setCloseInvoiceUploadModal: (state) => {
      state.openInvoiceUploadModal = false;
      state.modalUploadData = { data: [], headers: [] };
    },
    setOpenInvoiceListModal: (state, { payload }) => {
      state.openInvoiceListModal = true;
      state.modalListData = payload;
    },
    setCloseInvoiceListModal: (state) => {
      state.openInvoiceListModal = false;
      state.modalListData = [];
    },
    setOpenDocumentUploadModal: (state, { payload }) => {
      state.openDocumentUploadModal = true;
      state.modalDocumentUploadData = {
        data: payload.data || [],
        headers: payload.headers || [],
        invoiceNumber: payload.invoiceNumber || "",
        isViewMode: payload.isViewMode || false,
        shipmentMethod: payload.shipmentMethod || state.modalDocumentUploadData.shipmentMethod || "truck",
        documentsData: payload.documentsData || state.modalDocumentUploadData.documentsData || null,
      };

    },

    setCloseDocumentUploadModal: (state) => {
      state.openDocumentUploadModal = false;
      state.modalDocumentUploadData = {
        data: [],
        headers: [],
        invoiceNumber: "",
        isViewMode: false,
        shipmentMethod: "truck",
        documentsData: null,
      };

    },

    setOpenInvoiceDataStoreModal: (state, { payload }) => {
      state.openInvoiceDataStoreModal = true;
      state.modalUploadDataStore = payload;
    },
    setCloseInvoiceDataStoreModal: (state) => {
      state.openInvoiceDataStoreModal = false;
      state.modalUploadDataStore = { data: [], headers: [] };
    },
    setShippingData: (state, { payload }) => {
      state.shippingData = payload;
    },
    clearShippingData: (state) => {
      state.shippingData = null;
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(FetchInvoiceList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchInvoiceList.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.invoice = payload.data; // Store full invoice details
        state.totalRecord = payload?.totalRecord || 0;
      })
      .addCase(FetchInvoiceList.rejected, (state, { payload }) => {
        state.loading = false;
        state.error =
          (payload as { responseMessage?: string })?.responseMessage || "Failed to fetch invoice status";
      })
      .addCase(FetchInvoiceDetailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FetchInvoiceDetailList.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.invoiceDetails = payload.data;
        state.detailsTotalRecord = payload?.totalRecord || 0;
      })
      .addCase(FetchInvoiceDetailList.rejected, (state, { payload }) => {
        state.loading = false;
        state.error =
          (payload as { responseMessage?: string })?.responseMessage || "Failed to fetch invoice status";
      });
  },
});

export const { setOpenInvoiceModal, setCloseInvoiceModal, setOpenInvalidRowsModal, setCloseInvalidRowsModal, setOpenEditInvoiceModal, setCloseEditInvoiceModal, setOpenInvoiceUploadModal, setCloseInvoiceUploadModal, setOpenInvoiceListModal, setCloseInvoiceListModal, setOpenDocumentUploadModal, setCloseDocumentUploadModal , setOpenInvoiceDataStoreModal, setCloseInvoiceDataStoreModal, setShippingData, clearShippingData} = invoiceSlice.actions;

export const invoiceReducer = invoiceSlice.reducer;
